import { Type } from '@sinclair/typebox';
import { priceMajorMinorSimpleSchema } from "../price.mjs";
export const taxTypeSchema = Type.Union([Type.Literal('vat'), Type.Literal('salesTax')]);
export const taxErrorCodesSchema = Type.Union([
    // TaxJar Error Codes
    Type.Literal('taxjar_taxfororder_failed'),
    Type.Literal('taxjar_no_shipping_address_found'),
    Type.Literal('taxjar_missing_required_address_data'),
    Type.Literal('taxjar_invalid_postal_code'),
    // Stripe Error Codes (specific ones we handle)
    Type.Literal('stripe_param_validation_error'),
    Type.Literal('stripe_unknown_error'),
    // Stripe Error Codes (unspecific)
    Type.String(),
    // General error codes
    Type.Literal('internal_error'),
]);
export const taxSchema = Type.Object({
    id: Type.Optional(Type.String()),
    amountTotal: priceMajorMinorSimpleSchema,
    type: taxTypeSchema,
    rate: Type.Number(),
    isTaxExempt: Type.Union([Type.Boolean(), Type.Null()]),
    isFreightTaxable: Type.Optional(Type.Boolean()),
    error: Type.Optional(Type.Object({
        code: taxErrorCodesSchema,
    })),
});
export const vatNumberValidationStatusSchema = Type.Union([Type.Literal('validated'), Type.Literal('invalid'), Type.Literal('not validated')]);
//# sourceMappingURL=tax.js.map